module.exports = __webpack_public_path__ + "img/tata-cara-pengaduan.8ec4cd37.png";